import { render, staticRenderFns } from "./ScrollPane.vue?vue&type=template&id=2254f4e4&scoped=true&"
import script from "./ScrollPane.vue?vue&type=script&lang=ts&"
export * from "./ScrollPane.vue?vue&type=script&lang=ts&"
import style0 from "./ScrollPane.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ScrollPane.vue?vue&type=style&index=1&id=2254f4e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2254f4e4",
  null
  
)

export default component.exports